import React, { useEffect, useState } from "react";
import {
  Box,
  Divider,
  TextField,
  Typography,
  FormControl,
  Autocomplete,
} from "@mui/material";
import { isFormNotComplete, isFormNotError } from "../../../../utils";
import { APIEndpoint } from "../../../../client/apiconfig";
import axios from "axios";
import { Prefix } from "../../../../intefaces/VerifyCendential";
import { BasicAuthUser } from "../../../../client/basicAuth";

interface CertType {
  hospital_code: string;
  hospital_type: string;
  ref_code: string;
  sequence: number;
  verifiable_credential_type_code: string;
  verifiable_credential_type_name_en: string;
  verifiable_credential_type_name_th: string;
}

// ข้อมูลบุคลากร
interface Staff {
  person_name: string; // กำหนดให้ตรงกับโครงสร้างข้อมูลที่ API ส่งมา
}

// ข้อมูลแผนก
interface Department {
  department_no: number;
  department_code: string;
  department_name_th: string;
  department_name_eng: string;
  created_by: string;
  updated_by: string;
  is_active: boolean;
  is_delete: boolean;
}

interface FormData {
  certificateType: string;
  staff: string;
  department: string;
  licenseNumber: string;
  prefix: string;
}

interface Step1Props {
  onValueChange: (value: boolean, objData?: any) => void;
}

export const Step1Edit = ({ onValueChange }: Step1Props) => {
  const [formData, setFormData] = useState<FormData>({
    certificateType: "",
    staff: "",
    department: "",
    licenseNumber: "",
    prefix: "",
  });
  const [staff, setStaff] = useState<Staff[]>([]);
  const [department, setDepartment] = useState<Department[]>([]);
  const [certificatetype, setCertificatetype] = useState<CertType[]>([]);
  const [doctorPrefix, setDoctorPrefix] = useState<Prefix[]>([]);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  //  const username = process.env.REACT_APP_BASIC_AUTH_USERNAME;
  //   const password = process.env.REACT_APP_BASIC_AUTH_PASSWORD;

  //   if (!username || !password) {
  //     throw new Error("Basic Auth env variables are missing");
  //   }

  //   const BasicAuthUser = {
  //     username,
  //     password,
  //   };

  const handleFormChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    validateField(name, value);
  };

  const validateField = (name: string, value: string) => {
    let error = "";
    if (!value) {
      error = "กรุณาระบุข้อมูล";
    } else {
      switch (name) {
        case "licenseNumber":
          if (!/^\d+$/.test(value)) {
            error = "ระบุเป็นตัวเลขเท่านั้น";
          } else if (value.length !== 5) {
            error = "ระบุเลข 5 หลัก";
          }
          break;
        // Add more cases for other fields if needed
        default:
          break;
      }
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const getAuthorForm = async () => {
    const data = await sessionStorage.getItem("authorizeForm");
    // console.log("authorizeForm: ", data);
    if (data) {
      setFormData(JSON.parse(data));
    }
  };

  const fetchAllCertType = async () => {
    try {
      const res = await axios.get(APIEndpoint.GetAllCertType, {
        auth: BasicAuthUser,
      });
      if (res.data) {
        const certTypeData = res.data;
        setCertificatetype(certTypeData.result);
      }
    } catch (error) {
      console.error("Failed to fetch certificate types: ", error);
    }
  };

  const fetchDoctorName = async () => {
    try {
      let hcodeData = sessionStorage.getItem("hcode");
      if (hcodeData) {
        hcodeData = hcodeData.substring(1, hcodeData.length - 1);
        const response = await axios.get(APIEndpoint.DoctorName + hcodeData, {
          auth: BasicAuthUser,
        });
        // console.log("response doctorName: ", response);
        if (response.data) {
          const doctorName = response.data;
          setStaff(doctorName.result);
        }
      } else {
        console.error("hcodeData is null");
        throw new Error("hcodeData is null");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDepartment = async () => {
    try {
      const responseDepartment = await axios.get(APIEndpoint.Department, {
        auth: BasicAuthUser,
      });
      if (responseDepartment.data) {
        const departmentData = responseDepartment.data;
        setDepartment(departmentData.result);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
    }
  };

  const fetchDoctorPrefix = async () => {
    try {
      const responsePrefix = await axios.get(APIEndpoint.Prefix, {
        auth: BasicAuthUser,
      });
      if (responsePrefix.data) {
        const prefixData = responsePrefix.data;
        setDoctorPrefix(prefixData.result);
      }
    } catch (error) {
      console.error("Error fetching prefix data:", error);
    }
  };

  useEffect(() => {
    // update flow will override create flow
    const getDocMode = sessionStorage.getItem("docMode");
    if (getDocMode === "edit") {
      // get data from localStorage
      const docData = sessionStorage.getItem("document");
      if (docData) {
        const parseData = JSON.parse(docData);
        // console.log("docData: ", parseData);
        const { json_description } = parseData;
        const { creator } = json_description;
        const personName = creator.first_name + " " + creator.last_name;

        // set data to form
        setFormData({
          certificateType: parseData.type,
          staff: personName,
          department: creator.department,
          licenseNumber: creator.license_no,
          prefix: creator.prefix,
        });
      }
    } else {
      // create flow is here
      getAuthorForm();
    }

    // fetch API HERE:
    fetchDoctorName();
    fetchDepartment();
    fetchAllCertType();
    fetchDoctorPrefix();
  }, []);

  useEffect(() => {
    if (isFormNotComplete(formData)) {
      onValueChange(true);
      // console.log("form is not complete");
    } else {
      // make sure all fields are valid by send errors to isFormNotError
      if (isFormNotError(errors)) {
        onValueChange(true);
      } else {
        // console.log("formData: ", formData);
        onValueChange(false, { data: formData, key: "authorizeForm" });
      }
    }
  }, [formData]);

  return (
    <React.Fragment>
      <Typography variant="h5" sx={{ mb: 4 }}>
        ประเภทใบรับรองและบุคคลากรผู้มีสิทธิ์ลงนาม
      </Typography>

      <form>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Typography sx={{ mr: 2, color: "#5B5B5B" }}>
            ประเภทใบรับรอง
          </Typography>
          <Divider sx={{ flexGrow: 1, borderColor: "#98999B" }} />
        </Box>

        <Box display="flex" flexDirection="row" gap={1} sx={{ mt: 3, mb: 6 }}>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              options={certificatetype}
              getOptionLabel={(option) =>
                option.verifiable_credential_type_name_th
              }
              value={
                formData.certificateType
                  ? certificatetype.find(
                      (option) =>
                        option.verifiable_credential_type_code ===
                        formData.certificateType
                    )
                  : null
              }
              onChange={(event, newValue) => {
                handleFormChange({
                  target: {
                    name: "certificateType",
                    value: newValue
                      ? newValue.verifiable_credential_type_code
                      : "",
                  },
                });
              }}
              onBlur={() => {
                validateField("certificateType", formData.certificateType);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="ประเภทใบรับรอง"
                  variant="outlined"
                  error={!!errors.certificateType}
                  helperText={errors.certificateType}
                />
              )}
              isOptionEqualToValue={(option, value) =>
                option.verifiable_credential_type_code ===
                value?.verifiable_credential_type_code
              }
            />
          </FormControl>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography sx={{ mr: 2, color: "#5B5B5B" }}>
            ข้อมูลบุคคลากรผู้มีสิทธิ์ลงนาม
          </Typography>
          <Divider sx={{ flexGrow: 1, borderColor: "#98999B" }} />
        </Box>
        <Box display="flex" flexDirection="row" gap={1} sx={{ mt: 3 }}>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              options={doctorPrefix} // The array of options
              getOptionLabel={(option) => option.prefix_abbr_th} // Specify which field to display
              value={
                formData.prefix
                  ? doctorPrefix.find(
                      (option) => option.prefix_abbr_th === formData.prefix
                    )
                  : null
              }
              onChange={(event, newValue) => {
                handleFormChange({
                  target: {
                    name: "prefix",
                    value: newValue ? newValue.prefix_abbr_th : "",
                  },
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="คำนำหน้าชื่อ"
                  variant="outlined"
                  error={!!errors.prefix}
                  helperText={errors.prefix}
                  onBlur={() => {
                    validateField("prefix", formData.prefix);
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) =>
                option.prefix_abbr_th === value?.prefix_abbr_th
              } // Updated comparison
            />
          </FormControl>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              options={staff} // The array of options
              getOptionLabel={(option) => option.person_name} // Specify which field to display
              value={
                formData.staff
                  ? staff.find(
                      (option) => option.person_name === formData.staff
                    )
                  : null
              }
              onChange={(event, newValue) => {
                handleFormChange({
                  target: {
                    name: "staff",
                    value: newValue ? newValue.person_name : "",
                  },
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="กรุณาเลือกรายชื่อบุคลากร"
                  variant="outlined"
                  error={!!errors.staff}
                  helperText={errors.staff}
                  onBlur={() => {
                    validateField("staff", formData.staff);
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) =>
                option.person_name === value?.person_name
              } // Updated comparison
            />
          </FormControl>
        </Box>
        <Box
          display="flex"
          flexDirection={{
            xs: "column",
            sm: "column",
            md: "column",
            lg: "row",
          }}
          gap={2}
          sx={{ mt: 3 }}
        >
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              options={department} // The array of options
              getOptionLabel={(option) => option.department_name_th} // Specify which field to display
              value={
                formData.department
                  ? department.find(
                      (option) => option.department_code === formData.department
                    )
                  : null
              }
              onChange={(event, newValue) => {
                handleFormChange({
                  target: {
                    name: "department",
                    value: newValue ? newValue.department_code : "",
                  },
                });
              }}
              onBlur={() => {
                validateField("department", formData.department);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="กรุณาเลือกแผนก"
                  variant="outlined"
                  error={!!errors.department}
                  helperText={errors.department}
                />
              )}
              isOptionEqualToValue={(option, value) =>
                option.department_code === value?.department_code
              }
            />
          </FormControl>

          <TextField
            name="licenseNumber"
            label="ใบอนุญาตประกอบวิชาชีพเวชกรรมเลขที่"
            variant="outlined"
            fullWidth
            onChange={handleFormChange}
            onBlur={(e) => validateField(e.target.name, e.target.value)}
            value={formData.licenseNumber}
            error={!!errors.licenseNumber}
            helperText={errors.licenseNumber}
            inputProps={{
              maxLength: 5,
            }}
            sx={{
              flexGrow: 1,
            }}
          />
        </Box>
      </form>
    </React.Fragment>
  );
};

export default Step1Edit;
